/**
 * Modal and localStorage helper functions for Student Dashboard
 */

/**
 * Generate completion key for localStorage
 * @param {string} userId - User ID
 * @param {string} pathId - Path ID
 * @returns {string} Storage key
 */
export const getCompletionKey = (userId, pathId) => `completionShown_${userId}_${pathId}`;

/**
 * Get stored completion status from localStorage
 * @param {string} userId - User ID
 * @param {string} pathId - Path ID
 * @returns {boolean} True if completion was already shown
 */
export const getStoredCompletion = (userId, pathId) => {
  if (!userId || !pathId) return false;
  const key = getCompletionKey(userId, pathId);
  return localStorage.getItem(key) === 'true';
};

/**
 * Set completion status in localStorage
 * @param {string} userId - User ID
 * @param {string} pathId - Path ID
 * @param {boolean} value - Completion status to store
 */
export const setStoredCompletion = (userId, pathId, value) => {
  if (!userId || !pathId) return;
  const key = getCompletionKey(userId, pathId);
  if (value) {
    localStorage.setItem(key, 'true');
  } else {
    localStorage.removeItem(key);
  }
};

/**
 * Debug helper for modal state changes
 * @param {boolean} value - New modal state
 * @param {Object} context - Additional context for debugging
 */
export const logModalStateChange = (value, context = {}) => {
};